<template>
  <!-- Navbar -->
  <div
    class="navbar-fixed-top"
    :style="{
      backgroundImage: `url(${require('@/assets/img/app/header-bg.png')})`,
    }"
  >
    <nav
      class="top-0 navbar navbar-expand-lg position-absolute z-index-3 navbar-transparent w-100 blur py-2 start-0 end-0 shadow"
    >
      <div class="container">
        <!-- ボタン -->
        <button
          v-if="
            ![
              '/service/translation',
              '/service/ocr',
              '/service/image-generation',
            ].includes($route.path)
          "
          class="btn btn-fixed-menu-sp text-white shadow-none position-fixed px-1 mt-n2"
          @click="toggleSidenav"
        >
          <i class="fas fa-chevron-right fa-2x"></i><br />
          <span class="small mt-1">左メニュー</span>
        </button>

        <router-link
          class="navbar-brand font-weight-bolder ms-lg-0 ms-3 text-black"
          :class="{
            'ms-6':
              ![
                '/service/translation',
                '/service/ocr',
                '/service/image-generation',
              ].includes($route.path) && $store.state.isMobileOpen,
          }"
          to="/"
        >
          <img
            :src="require('@/assets/img/auth/MI-chao_logo_menu.png')"
            style="width: 110px"
            alt="Logo"
          />
        </router-link>
        <button
          class="btn-fixed-menu-close-sp shadow-none position-fixed navbar-toggler end-0"
          type="button"
          @click="isOpen = !isOpen"
          data-bs-toggle="collapse"
          data-bs-target="#navigation"
          aria-controls="navigation"
          aria-label="Toggle navigation"
          :aria-expanded="isOpen"
        >
          <span class="mt-2 navbar-toggler-icon">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </span>
        </button>

        <div
          id="navigation"
          class="pt-3 pb-2 collapse navbar-collapse w-100 py-lg-0"
          :class="{ collapse: !isOpen, show: isOpen }"
        >
          <ul class="mx-auto navbar-nav navbar-nav-hover">
            <li
              v-for="feature in filteredFeatures"
              :key="feature.route"
              class="nav-item"
            >
              <router-link
                :to="feature.route"
                class="nav-link text-white px-3 w-100"
                exact-active-class="active-link"
                @click="closeMenu"
              >
                <img
                  class="nav-menu-icon me-1"
                  :src="require(`@/assets/img/app/${feature.icon}`)"
                />
                <span>{{ feature.title }}</span>
                <!-- スマホだけ表示される矢印アイコン -->
                <div class="position-absolute nav-menu-icon-arrow-sp">
                  <i class="fas fa-chevron-right text-secondary h3"></i>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
  <router-view></router-view>
</template>

<script>
import { isTenantRoute } from '@/constants/tenants'

export default {
  data() {
    return {
      activeFeature: null, // Track the active feature
      isOpen: false,
      features: [
        {
          route: '/service/main-chat',
          icon: 'misocio-icon2.png',
          title: '相談しチャオ',
        },
        /*
        {
          route: '/service/search-chat',
          icon: 'misocio-icon3.png',
          title: '検索しチャオ',
        },
         */
        {
          route: '/service/rag-chat',
          icon: 'misocio-icon4.png',
          title: 'RAGっチャオ',
        },
        {
          route: '/service/summary',
          icon: 'misocio-icon7.png',
          title: '議事録っチャオ',
        },
        {
          route: '/service/translation',
          icon: 'misocio-icon6.png',
          title: '翻訳しチャオ',
        },
        {
          route: '/service/ocr',
          icon: 'misocio-icon5.png',
          title: 'テキスト化しチャオ',
        },
        {
          route: '/service/image-generation',
          icon: 'misocio-icon8.png',
          title: '画像生成しチャオ',
        },
      ],
    }
  },
  methods: {
    closeMenu() {
      this.isOpen = false
      // スマホで機能メニューを選択した際は、左メニュ－を非表示にさせページ遷移を行う
      if (this.$store.state.isMobileOpen) {
        this.$store.commit('setSidenavState', false)
      }
    },
    toggleSidenav() {
      // Vuexに状態を反映
      this.$store.commit('setSidenavState', !this.$store.state.isSidenavOpen)

      //const iframeWindow = this.$refs.iframe?.contentWindow
      const iframe = document.getElementById('perplexica-search-chat')
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ toggle: 'true' }, '*')
      }
    },
  },
  computed: {
    filteredFeatures() {
      if (isTenantRoute(this.$route)) {
        return []
      } else {
        return this.features
      }
    },
  },
}
</script>

<style scoped>
CHeaderNav {
  flex-grow: 1;
  justify-content: center;
}

CNavLink {
  margin: 0 15px;
  font-size: 18px;
  color: #0c2231;
  cursor: pointer;
}

CNavLink:hover {
  text-decoration: underline;
}
</style>
